import React from 'react';
import { styled } from '@mui/material/styles';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { KitButton } from 'components/common/cms-kit';
import { useSession } from 'next-auth/react';

const Container = styled('div')(({ $backgroundImageUrl, $imageLocation }) => ({
  display: 'flex',
  flexFlow: 'row',
  justifyContent: 'center',
  alignItems: 'flex-end',
  backgroundImage: `url('${$backgroundImageUrl}')`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  flexDirection: $imageLocation === 'left' ? 'row-reverse' : 'row',
  padding: '0 30px',
  position: 'relative',
  '@media screen and (max-width: 899px)': {
    minHeight: '150px',
  },
  '@media screen and (min-width: 900px)': {
    minHeight: '475px',
  },
}));

const EmptyContainer = styled('div')(({ $imageLocation }) => ({
  flexGrow: 1,
  flexShrink: 0,
  flex: 1,
  verticalAlign: 'top',
  '@media screen and (max-width: 899px)': {
    display: 'none',
  },
  '@media screen and (min-width: 900px)': {
    padding: '60px 10px',
    flexDirection: $imageLocation === 'left' ? 'row-reverse' : 'row',
    maxWidth: $imageLocation === 'center' ? '20%' : '50%',
  },
}));

const FloatingButton = styled('div')(({ $imageLocation }) => ({
  verticalAlign: 'top',
  padding: '60px 10px',
  position: 'absolute',
  top: '60%',
  left: '57%',
  flexDirection: $imageLocation === 'left' ? 'row-reverse' : 'row',
  maxWidth: $imageLocation === 'center' ? '20%' : '50%',
  '@media screen and (max-width: 899px)': {
    display: 'none',
  },
}));

const MobileFloatingButton = styled('div')(({ $imageLocation }) => ({
  verticalAlign: 'top',
  padding: '15px 10px',
  position: 'absolute',
  top: '66%',
  left: '55%',
  flexDirection: $imageLocation === 'left' ? 'row-reverse' : 'row',
  maxWidth: $imageLocation === 'center' ? '20%' : '50%',
  '@media screen and (min-width: 900px)': {
    display: 'none',
  },
}));

const ImageContainer = styled('div')(({ $imageLocation }) => ({
  margin: 0,
  position: 'relative',
  '@media screen and (min-width: 900px)': {
    maxWidth: $imageLocation === 'center' ? '43%' : '50%',
    marginLeft: '9%',
    height: '100%',
  },
  '@media screen and (max-width: 899px)': {
    maxWidth: $imageLocation === 'center' ? '75%' : '50%',
    marginLeft: '15%',
    height: '135%',
  },
}));

const ActionImageandButtonWithBackground = ({ module }) => {
  const { fields } = module;

  const router = useRouter();
  const { data: session } = useSession();

  const _callAction = (event) => {
    event.preventDefault();
    router.push(fields.actionButtonUrl.href);
  };

  return (
    <React.Fragment>
      {!session && (
        <Container $backgroundImageUrl={fields.backgroundImage.url} $imageLocation={fields.imageLocation}>
          <EmptyContainer $imageLocation={fields.imageLocation}></EmptyContainer>
          <ImageContainer $imageLocation={fields.imageLocation}>
            {fields.heroImage && (
              <img src={fields.heroImage.url} alt={fields.heroImage.text} />
            )}
            <>
              <FloatingButton $imageLocation={fields.imageLocation}>
                {fields.buttonUrl &&
                  fields.buttonUrl.href &&
                  fields.buttonUrl.href.length > 0 && (
                    <a
                      href={fields.buttonUrl.href}
                      target={fields.buttonUrl.target}
                      rel="noopener noreferrer"
                    >
                      <KitButton color={fields.buttonColor} round>
                        {fields.buttonText}
                      </KitButton>
                    </a>
                  )}
              </FloatingButton>
              <MobileFloatingButton $imageLocation={fields.imageLocation}>
                {fields.buttonUrl &&
                  fields.buttonUrl.href &&
                  fields.buttonUrl.href.length > 0 && (
                    <Link href={fields.buttonUrl.href}>
                      <KitButton color={fields.buttonColor} round>
                        <a
                          href={fields.buttonUrl.href}
                          target={fields.buttonUrl.target}
                          rel="noopener noreferrer"
                        >
                          {fields.buttonText}
                        </a>
                      </KitButton>
                    </Link>
                  )}
              </MobileFloatingButton>
            </>
          </ImageContainer>
        </Container>
      )}
    </React.Fragment>
  );
};

export default ActionImageandButtonWithBackground;
